interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-12">
            <a href="/" className={`text-2xl font-bold transition-colors duration-300 ${
              scrolled ? 'text-[#1A1F36]' : 'text-[#1A1F36]'
            }`}>
              PRAXIA
            </a>
            <div className="hidden md:flex items-center gap-8">
              <a
                href="#microcourses"
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                  scrolled ? 'text-gray-700 hover:text-[#304FFE]' : 'text-gray-600 hover:text-[#304FFE]'
                }`}
              >
                Microcourses
              </a>
              <a
                href="#badges"
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                  scrolled ? 'text-gray-700 hover:text-[#304FFE]' : 'text-gray-600 hover:text-[#304FFE]'
                }`}
              >
                Badges
              </a>
              <a
                href="#pathways"
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                  scrolled ? 'text-gray-700 hover:text-[#304FFE]' : 'text-gray-600 hover:text-[#304FFE]'
                }`}
              >
                Merit Pathways™
              </a>
              <a
                href="#about"
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                  scrolled ? 'text-gray-700 hover:text-[#304FFE]' : 'text-gray-600 hover:text-[#304FFE]'
                }`}
              >
                About
              </a>
            </div>
          </div>
          <button className="px-6 py-2.5 bg-gradient-to-r from-[#304FFE] to-[#7C4DFF] text-white text-sm font-medium rounded-full hover:shadow-lg hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
